import http from '../libs/http';

export const payBill = ({merchantId, paymentId}, payload) => {

    const endpoint = `/api/v3/merchants/${merchantId}/pay/${paymentId}`;
    return http({method: 'POST', endpoint, body: payload});
};
